/* =====================================================================
   TOTAL DE LA PAGE PANIER — correctif B2C
   Perle Dorée

   LE PROBLEME
   L'app BSS B2B réécrit le total de la page /cart après le chargement,
   via sa fonction showSubtotal. Elle additionne les prix AVANT remise et
   ignore les remises automatiques Shopify. Le thème, lui, affichait la
   bonne valeur : c'est BSS qui l'écrase.

   Exemple mesuré le 2026-09-02 : panier à 75,98 € réellement facturé,
   affiché 100,98 € sur /cart. Le tiroir latéral, lui, restait juste.

   CE QUE FAIT CE SCRIPT
   Il remet la valeur de cart.total_price, c'est à dire exactement ce que
   Shopify facturera au paiement.

   CE QU'IL NE FAIT PAS, ET C'EST LE POINT IMPORTANT
   Il ne touche RIEN dès que BSS a la main sur les prix. Si le visiteur
   est un compte B2B, s'il est rattaché à une société, ou si BSS signale
   avoir modifié des prix, le script s'abstient totalement. Les tarifs
   B2B restent ceux de l'app, sans exception.

   Il ne modifie aucun prix : il corrige un affichage.
   ===================================================================== */
(function () {
  'use strict';

  var SELECTEUR = '.xo-cart-totals__value';
  var MARQUE = 'pdTotalCorrige';

  // Page panier uniquement. Le tiroir latéral n'est pas concerné.
  if (!/^\/cart\/?$/.test(window.location.pathname)) return;

  var devise = null;
  function formater(centimes) {
    if (!devise) {
      try {
        var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
        devise = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: code });
      } catch (e) { return null; }
    }
    return devise.format(centimes / 100);
  }

  /* Garde-fou B2B : au moindre signe que BSS pilote les prix, on sort.
     Réévalué à chaque passage, parce que BSS renseigne son contexte
     client de façon asynchrone après le chargement de la page. */
  function bssPiloteLesPrix() {
    var b = window.BSS_B2B;
    if (!b) return false;
    if (b.isModifiedPrice) return true;
    var c = b.shopData && b.shopData.customer;
    if (c && (c.isB2B || c.current_company || c.current_location)) return true;
    return false;
  }

  var enCours = false;
  var minuteur = null;

  function corriger() {
    if (enCours) return;
    var cible = document.querySelector(SELECTEUR);
    if (!cible || bssPiloteLesPrix()) return;

    enCours = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (panier) {
        if (!panier) return;
        // Aucune remise en jeu : rien à corriger, on laisse le thème et
        // l'app tranquilles plutôt que de réécrire pour rien.
        if (panier.total_price === panier.original_total_price) return;
        if (bssPiloteLesPrix()) return;      // le contexte a pu arriver entre temps

        var attendu = formater(panier.total_price);
        if (!attendu) return;

        var actuel = (cible.textContent || '').replace(/\s|\u00a0/g, '');
        if (actuel === attendu.replace(/\s|\u00a0/g, '')) return;   // déjà juste

        cible.textContent = attendu;
        cible.dataset[MARQUE] = '1';
      })
      .catch(function () {})
      .then(function () { enCours = false; });
  }

  function programmer() {
    clearTimeout(minuteur);
    minuteur = setTimeout(corriger, 150);
  }

  /* BSS écrit son total après coup, et le réécrit à chaque modification
     du panier. On surveille donc le conteneur en continu plutôt que de
     corriger une seule fois au chargement. */
  function observer() {
    var conteneur = document.querySelector('.xo-cart-totals') || document.body;
    if (!window.MutationObserver) return;
    new MutationObserver(programmer).observe(conteneur, {
      childList: true, subtree: true, characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observer(); programmer(); });
  } else {
    observer(); programmer();
  }

  document.addEventListener('cart:refresh', programmer);
  document.addEventListener('cart:updated', programmer);
})();
